export enum CryptoType {
    BTC = 'BTC',
    ETH = 'ETH',
    USDC = 'USDC',
}

export enum CryptoStep {
    option,
    sendPayment,
    tooMuch,
    notEnough,
}
